<audio #audioPlayer></audio>

<div class="banner full-width">
  @if (isFreeTrialSession && freeTrialMinsLeft() <= 3) {
    <nz-alert nzType="warning" [nzMessage]="freeTrialWarning()" nzShowIcon></nz-alert>
  }
  @if (!isDismiss && stopWorking) {
    <nz-alert
      nzType="error"
      nzMessage="Connection Issue"
      nzDescription="Oops, it seems you encountered a connection issue. You might want to reload the page to reconnect."
      nzShowIcon
      [nzAction]="actionStopWorking"
    ></nz-alert>

    <ng-template #actionStopWorking>
      <button nz-button [nzDanger]="true" nzType="primary" nzSize="large" (click)="onRefreshPageClick()">
        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">sync</span>
        Refresh Page
      </button>

      <button nz-button nzType="primary" nzSize="large" (click)="onDismissClick()">
        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">sync</span>
        Dismiss
      </button>
    </ng-template>
  }
  @if (micConnectStatus() === ConnectionStatus.loading) {
  } @else if (micConnectStatus() === ConnectionStatus.connected) {}
</div>

<div class="vertical body full-height full-width">
  <div class="horizontal full-height" [ngStyle]="{ gap: 0 }">
    <div #meetingBody class="left-panel">
      @if (isConfig) {
        <div class="body-config vertical-large config">
          <div class="page-header">
            <div class="page-title">Launching Simulated Meeting</div>
          </div>

          <div class="steps">
            <nz-steps [nzCurrent]="configStepIndex()" nzDirection="vertical" nzSize="small">
              <nz-step [nzTitle]="step1Title" [nzDescription]="step1">
                <ng-template #step1Title>
                  <div class="step-title">Enable Your Microphone Permission</div>
                </ng-template>
                <ng-template #step1>
                  <div class="vertical-large step-content">
                    <div class="horizontal">
                      <div>
                        Click "Allow" when the browser asks for your microphone permission. Move to a quieter place or
                        put on your headphone for best results!
                      </div>
                      <!-- <div>
                        <app-image-open-in-full
                          [width]="'170px'"
                          [src]="'/assets/images/setup-session-copilot/step1_v1.png'"
                        ></app-image-open-in-full>
                      </div> -->
                    </div>
                  </div>
                </ng-template>
              </nz-step>

              <nz-step [nzTitle]="step2Title" [nzDescription]="step2">
                <ng-template #step2Title>
                  <div class="step-title">Select your Computer Audio</div>
                </ng-template>

                <ng-template #step2>
                  <div class="vertical-large step-content">
                    <div>Select the microphone you're using during your practice.</div>

                    <nz-select [(ngModel)]="selectedMicrophone">
                      @for (item of microphoneList(); track $index) {
                        <nz-option [nzValue]="item" [nzLabel]="item.label"></nz-option>
                      }
                    </nz-select>
                  </div>
                </ng-template>
              </nz-step>

              <nz-step [nzTitle]="step3Title" [nzDescription]="step3">
                <ng-template #step3Title>
                  <div class="step-title">Select your Camera</div>
                </ng-template>

                <ng-template #step3>
                  <div class="vertical-large step-content">
                    <div>Select the Camera you're using during your practice.</div>

                    <nz-select [ngModel]="selectedCamera" (ngModelChange)="onCameraSelect($event)">
                      @for (item of cameraList(); track $index) {
                        <nz-option [nzValue]="item" [nzLabel]="item.label"></nz-option>
                      }
                    </nz-select>
                  </div>
                </ng-template>
              </nz-step>

              <nz-step [nzTitle]="grantRecordingPermissionTitle" [nzDescription]="grantRecordingPermission">
                <ng-template #grantRecordingPermissionTitle>
                  <div class="step-title">Grant Recording Permission</div>
                </ng-template>

                <ng-template #grantRecordingPermission>
                  <div class="vertical-large step-content">
                    <div>
                      Select the current browser tab, ensure the "Also allow tab audio" option is checked, and then
                      click "Allow".
                    </div>

                    <button
                      class="fit-content"
                      nz-button
                      nzType="primary"
                      nzSize="large"
                      (click)="onGrantPermissionClick()"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">screen_share</span>
                      Share Browser Tab
                    </button>
                  </div>
                </ng-template>
              </nz-step>
            </nz-steps>
            <div class="horizontal" [ngStyle]="{ justifyContent: 'center' }">
              <button
                class="fit-content"
                nz-button
                nzType="primary"
                nzSize="large"
                [matTooltip]="isStartButtonDisabled() ? 'Please click `Share Browser Tab` to continue.' : ''"
                [disabled]="isStartButtonDisabled()"
                (click)="onStartClick()"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">rocket_launch</span>
                I'm ready!
              </button>
            </div>
          </div>
        </div>
      } @else {
        <div [ngClass]="isStartedVideo() ? 'video-window-list-side-by-side' : 'video-window-list'" class="horizontal">
          <div class="video-window sales-window" [ngStyle]="isUserSpeaking() ? { borderColor: '#00d851' } : undefined">
            <video
              [ngStyle]="!isStartedVideo() ? { display: 'none' } : {}"
              id="userCamera"
              autoplay
              playsinline
            ></video>
            @if (!isStartedVideo()) {
              <img class="portrait" [src]="sales().portrait" />
            }
          </div>
          <div
            class="video-window customer-window"
            [ngClass]="{ 'breathing-border': isAiThinking() }"
            [ngStyle]="isAiThinking() ? { borderColor: '#ffc300' } : isAiSpeaking() ? { borderColor: '#00d851' } : {}"
          >
            <img class="portrait" [src]="customer().portrait" />
            <div class="name">{{ customer().name }}</div>
          </div>
        </div>
      }
      <div class="horizontal center toolbar">
        <div class="toolbar-buttons horizontal-large">
          <!-- <div class="toolbar-button no-select customer-video" [matTooltip]="'Request AI to turn on video [Beta]'">
            <div nz-icon style="font-size: 30px" class="material-symbols-rounded">video_camera_front</div>
            <div>Customer Video</div>

            <div class="coming-soon">Beta</div>
          </div> -->
          <div class="toolbar-button no-select" (click)="onMuteClick()" [ngClass]="isMuted() ? ['is-active'] : []">
            <div nz-icon style="font-size: 30px" class="material-symbols-rounded">
              {{ isMuted() ? 'mic_off' : 'mic' }}
            </div>
            <div>{{ isMuted() ? 'Unmute' : 'Mute' }}</div>
          </div>
          <div
            class="toolbar-button no-select"
            (click)="onStartVideoClick()"
            [ngClass]="isStartedVideo() ? ['is-active'] : []"
          >
            <div nz-icon style="font-size: 30px" class="material-symbols-rounded">
              {{ isStartedVideo() ? 'videocam_off' : 'videocam' }}
            </div>
            <div>Video</div>
          </div>
          <div class="toolbar-button no-select" [matTooltip]="'Coming Soon...'">
            <div nz-icon style="font-size: 30px" class="material-symbols-rounded">present_to_all</div>
            <div>Share Screen</div>
          </div>
          <div
            class="toolbar-button no-select"
            (click)="onChatClick()"
            [ngClass]="showChatMessage() ? ['is-active'] : []"
          >
            <div nz-icon style="font-size: 30px" class="material-symbols-rounded">chat</div>
            <div>Chat</div>
          </div>
          <div class="toolbar-button no-select" [matTooltip]="'Coming Soon...'">
            <div nz-icon style="font-size: 30px" class="material-symbols-rounded">description</div>
            <div>Assistant</div>
          </div>
        </div>

        <div
          class="end-button"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you’d like to end the call?"
          (nzOnConfirm)="onEndSessionClick()"
        >
          End
        </div>
      </div>
    </div>
    @if (showChatMessage()) {
      <div class="message-list" [@slideInOut]>
        <div class="message-list-title horizontal">
          <div>Sales Meeting Room</div>
          <div class="close-button" (click)="onChatClick()">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">close</span>
          </div>
        </div>
        <div class="message-body" #chatMessages>
          @for (message of messageList(); track $index; let even = $even) {
            @if (message) {
              <div [@fadeInOut] class="message horizontal">
                <img class="portrait" [src]="even ? customer().portrait : sales().portrait" />
                <div class="content">{{ message }}</div>
              </div>
            }
          }

          @if (isAiThinking()) {
            <div [@fadeInOut] class="message horizontal">
              <img class="portrait" [src]="customer().portrait" />
              <div class="content">...</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

<nz-modal
  [(nzVisible)]="isNeedToShareAudioModalVisible"
  nzTitle="Please share your tab with audio."
  [nzCancelDisabled]="true"
  [nzOkText]="'Refresh Page.'"
  (nzOnOk)="handleNeedToShareAudioModalOk()"
>
  <ng-container *nzModalContent>
    <p>Please share your tab with audio. Refresh the page to try again.</p>
  </ng-container>
</nz-modal>

<app-session-survey [(isVisible)]="isEndSurveyVisible" [session]="session()!"></app-session-survey>

<app-text-image-modal
  [isVisible]="showSessionEndModal()"
  title="Practice Ended"
  content="Your current practice session has ended. You can start a new practice if needed."
  okText="End Practice"
  (okClick)="onEndSessionClick()"
  [cancelText]="undefined"
  [closable]="false"
></app-text-image-modal>

<ng-template #notificationBtnTpl let-notification>
  <button nz-button nzType="primary" [nzDanger]="true" nzSize="small" (click)="onMicReconnectClick(notification)">
    Confirm
  </button>
</ng-template>
